import { IMAGE_CLOUD_NAME } from "../settings";

export const deleteImageFromCloudinery = token => {
  return fetch(`https://api.cloudinary.com/v1_1/${IMAGE_CLOUD_NAME}/delete_by_token`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ token })
  });
};
